(() => {
  const ADD_TO_CART_TEXT = 'Agregar al carrito';
  const DIRECT_BUY_MAIN_TEXT = 'Realizar pedido';
  const DIRECT_BUY_SUB_TEXT = 'Pagás al recibir. Confirmamos por WhatsApp.';
  const DIRECT_BUY_LOADING_MAIN_TEXT = 'Verificando stock';
  const DIRECT_BUY_LOADING_SUB_TEXT = 'Confirmando unidades disponibles...';
  const DIRECT_BUY_LABEL_VERSION = 'premium-cod-v3';
  const DIRECT_BUY_LOADING_LABEL_VERSION = 'premium-loading-v3';
  const ADD_TO_CART_BUTTON_SELECTOR = '.product-form__submit[name="add"], .premium-add-btn';
  const PREMIUM_ADD_BUTTON_SELECTOR = '.premium-add-btn';
  const DIRECT_BUY_BUTTON_SELECTOR = '.shopify-payment-button__button--unbranded';
  const STICKY_DIRECT_BUY_QUERY = '(max-width: 749px)';
  const CHECKOUT_NAVIGATION_TIMEOUT = 15000;
  let checkoutFailureTimer;
  let checkoutProgressTimer;
  let checkoutFocusTarget;

  const cssEscape = (value) => {
    if (window.CSS && typeof window.CSS.escape === 'function') return window.CSS.escape(value);
    return String(value).replace(/"/g, '\\"');
  };

  const stickyDirectBuyMedia = window.matchMedia ? window.matchMedia(STICKY_DIRECT_BUY_QUERY) : null;

  const isDisabledButton = (button) => button.disabled || button.getAttribute('aria-disabled') === 'true';
  const isDirectBuyLoading = (button) => button.classList.contains('ct-adapter-checkout-loading');

  const setDirectBuyButtonLabel = (button, loading = false) => {
    const labelVersion = loading ? DIRECT_BUY_LOADING_LABEL_VERSION : DIRECT_BUY_LABEL_VERSION;
    const mainText = loading ? DIRECT_BUY_LOADING_MAIN_TEXT : DIRECT_BUY_MAIN_TEXT;
    const subText = loading ? DIRECT_BUY_LOADING_SUB_TEXT : DIRECT_BUY_SUB_TEXT;

    if (button.dataset.ctDirectBuyLabel === labelVersion) {
      if (button.hasAttribute('aria-label')) button.removeAttribute('aria-label');
      return;
    }

    const label = document.createElement('span');
    label.className = 'ct-direct-buy__label';

    const main = document.createElement('span');
    main.className = 'ct-direct-buy__main';
    main.textContent = mainText;

    const sub = document.createElement('span');
    sub.className = 'ct-direct-buy__sub';
    sub.textContent = subText;

    label.append(main, sub);
    button.replaceChildren(label);
    button.dataset.ctDirectBuyLabel = labelVersion;
    button.removeAttribute('aria-label');
  };

  const getDirectBuyButtons = () => Array.from(
    document.querySelectorAll(`${DIRECT_BUY_BUTTON_SELECTOR}, .ct-direct-buy-sticker__button`)
  );

  const createCheckoutOverlay = () => {
    const overlay = document.createElement('div');
    overlay.className = 'ct-checkout-transition';
    overlay.hidden = true;
    overlay.dataset.ctCheckoutTransition = 'true';
    overlay.setAttribute('role', 'status');
    overlay.setAttribute('aria-live', 'polite');
    overlay.setAttribute('aria-atomic', 'true');

    const backdrop = document.createElement('span');
    backdrop.className = 'ct-checkout-transition__backdrop';
    backdrop.setAttribute('aria-hidden', 'true');

    const panel = document.createElement('div');
    panel.className = 'ct-checkout-transition__panel';

    const orbit = document.createElement('span');
    orbit.className = 'ct-checkout-transition__orbit';
    orbit.setAttribute('aria-hidden', 'true');
    const mark = document.createElement('span');
    mark.className = 'ct-checkout-transition__mark';
    mark.textContent = 'CT';

    const successIcon = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
    successIcon.classList.add('ct-checkout-transition__success-icon');
    successIcon.setAttribute('viewBox', '0 0 24 24');
    successIcon.setAttribute('fill', 'none');
    successIcon.setAttribute('stroke', 'currentColor');
    successIcon.setAttribute('stroke-width', '2.2');
    successIcon.setAttribute('stroke-linecap', 'round');
    successIcon.setAttribute('stroke-linejoin', 'round');
    successIcon.setAttribute('aria-hidden', 'true');

    const successPath = document.createElementNS('http://www.w3.org/2000/svg', 'path');
    successPath.setAttribute(
      'd',
      'M7 10v12M15 5.88 14 10h5.83a2 2 0 0 1 1.92 2.56l-2.33 8A2 2 0 0 1 17.5 22H4a2 2 0 0 1-2-2v-8a2 2 0 0 1 2-2h2.76a2 2 0 0 0 1.79-1.11L12 2h0a3.13 3.13 0 0 1 3 3.88Z'
    );
    successIcon.appendChild(successPath);
    orbit.append(mark, successIcon);

    const eyebrow = document.createElement('span');
    eyebrow.className = 'ct-checkout-transition__eyebrow';
    eyebrow.textContent = 'CHECKOUT CHETIENDA';

    const title = document.createElement('strong');
    title.className = 'ct-checkout-transition__title';
    title.dataset.ctCheckoutTitle = 'true';
    title.textContent = 'Preparando tu checkout seguro';

    const copy = document.createElement('span');
    copy.className = 'ct-checkout-transition__copy';
    copy.dataset.ctCheckoutCopy = 'true';
    copy.textContent = 'Estamos llevando tu selección a la pantalla de pago.';

    const progress = document.createElement('span');
    progress.className = 'ct-checkout-transition__progress';
    progress.setAttribute('aria-hidden', 'true');
    progress.appendChild(document.createElement('span'));

    const reassurance = document.createElement('span');
    reassurance.className = 'ct-checkout-transition__reassurance';
    reassurance.dataset.ctCheckoutReassurance = 'true';
    reassurance.textContent = 'Esto tomará solo un instante.';

    panel.append(orbit, eyebrow, title, copy, progress, reassurance);
    overlay.append(backdrop, panel);
    document.body.appendChild(overlay);
    return overlay;
  };

  const getCheckoutOverlay = () => (
    document.querySelector('[data-ct-checkout-transition]') || createCheckoutOverlay()
  );

  const setCheckoutOverlayMessage = (titleText, copyText, reassuranceText) => {
    const overlay = getCheckoutOverlay();
    const title = overlay.querySelector('[data-ct-checkout-title]');
    const copy = overlay.querySelector('[data-ct-checkout-copy]');
    const reassurance = overlay.querySelector('[data-ct-checkout-reassurance]');
    if (title) title.textContent = titleText;
    if (copy) copy.textContent = copyText;
    if (reassurance && reassuranceText) reassurance.textContent = reassuranceText;
    return overlay;
  };

  const showCheckoutOverlay = () => {
    const overlay = setCheckoutOverlayMessage(
      'Verificando stock...',
      'Comprobando la disponibilidad de tu selección.',
      'Esto tomará solo un instante.'
    );
    overlay.classList.remove('is-error', 'is-success');
    overlay.hidden = false;
    overlay.setAttribute('aria-busy', 'true');
    document.body.classList.add('ct-checkout-transition-active');
    window.requestAnimationFrame(() => overlay.classList.add('is-visible'));
  };

  const hideCheckoutOverlay = () => {
    const overlay = document.querySelector('[data-ct-checkout-transition]');
    if (overlay) {
      overlay.classList.remove('is-visible', 'is-error', 'is-success');
      overlay.removeAttribute('aria-busy');
      overlay.hidden = true;
    }
    document.body?.classList.remove('ct-checkout-transition-active');
  };

  const rememberDirectBuyState = (button) => {
    if (button.dataset.ctDirectBuyWasDisabled !== undefined) return;
    button.dataset.ctDirectBuyWasDisabled = button.disabled ? 'true' : 'false';
    button.dataset.ctDirectBuyAriaDisabled = button.hasAttribute('aria-disabled')
      ? button.getAttribute('aria-disabled') || ''
      : '__missing__';
  };

  const restoreDirectBuyState = (button) => {
    if (button.dataset.ctDirectBuyWasDisabled !== undefined) {
      button.disabled = button.dataset.ctDirectBuyWasDisabled === 'true';
      delete button.dataset.ctDirectBuyWasDisabled;
    }

    if (button.dataset.ctDirectBuyAriaDisabled !== undefined) {
      const previousAriaDisabled = button.dataset.ctDirectBuyAriaDisabled;
      if (previousAriaDisabled === '__missing__') button.removeAttribute('aria-disabled');
      else button.setAttribute('aria-disabled', previousAriaDisabled);
      delete button.dataset.ctDirectBuyAriaDisabled;
    }
  };

  const setDirectBuyPending = (button) => {
    if (!button) return;

    checkoutFocusTarget = button;
    window.clearTimeout(checkoutFailureTimer);
    window.clearTimeout(checkoutProgressTimer);

    getDirectBuyButtons().forEach((candidate) => {
      rememberDirectBuyState(candidate);
      candidate.dataset.ctDirectBuyPending = 'true';
      candidate.classList.add('ct-adapter-checkout-loading', 'ct-direct-buy--engaging');
      candidate.setAttribute('aria-busy', 'true');
      candidate.setAttribute('aria-disabled', 'true');
      candidate.disabled = true;
      setDirectBuyButtonLabel(candidate, true);
    });

    showCheckoutOverlay();
    checkoutProgressTimer = window.setTimeout(() => {
      const overlay = setCheckoutOverlayMessage(
        'Preparando checkout',
        'Abriendo el checkout de Shopify para continuar.',
        'Esperá un momento, por favor.'
      );
      overlay.classList.add('is-success');
      overlay.removeAttribute('aria-busy');
    }, 360);
    checkoutFailureTimer = window.setTimeout(() => {
      resetDirectBuyPending({ showError: true, focusTarget: checkoutFocusTarget });
    }, CHECKOUT_NAVIGATION_TIMEOUT);
  };

  const resetDirectBuyPending = ({ showError = false, focusTarget = null } = {}) => {
    window.clearTimeout(checkoutFailureTimer);
    window.clearTimeout(checkoutProgressTimer);

    document.querySelectorAll('form[data-ct-checkout-pending="true"]').forEach((form) => {
      delete form.dataset.ctCheckoutPending;
    });

    getDirectBuyButtons().forEach((button) => {
      if (button.dataset.ctDirectBuyPending !== 'true') return;
      delete button.dataset.ctDirectBuyPending;
      restoreDirectBuyState(button);
      button.classList.remove('ct-adapter-checkout-loading', 'ct-direct-buy--engaging');
      button.removeAttribute('aria-busy');
      setDirectBuyButtonLabel(button, false);
      delete button.ctDirectBuyOriginalMarkup;
    });

    if (showError) {
      const overlay = setCheckoutOverlayMessage(
        'No pudimos abrir el checkout',
        'Tu selección sigue acá. Intentá nuevamente.'
      );
      overlay.classList.remove('is-success');
      overlay.classList.add('is-error', 'is-visible');
      overlay.removeAttribute('aria-busy');
      checkoutProgressTimer = window.setTimeout(() => {
        hideCheckoutOverlay();
        if (focusTarget && document.contains(focusTarget) && !focusTarget.disabled) {
          focusTarget.focus({ preventScroll: true });
        }
      }, 2600);
    } else {
      hideCheckoutOverlay();
    }

    checkoutFocusTarget = null;
  };

  const syncStickyBodyState = () => {
    if (!document.body) return;
    document.body.classList.toggle('ct-direct-buy-is-stuck', Boolean(document.querySelector('.ct-direct-buy-sticker.is-visible')));
  };

  const initStickyDirectBuyButton = (button) => {
    const wrapper = button.closest('.shopify-payment-button');
    if (!wrapper || !wrapper.parentNode || !document.body || wrapper.dataset.ctStickyReady === 'true') return;

    wrapper.dataset.ctStickyReady = 'true';
    wrapper.classList.add('ct-direct-buy');

    const sentinel = document.createElement('span');
    sentinel.className = 'ct-direct-buy-sentinel';
    sentinel.setAttribute('aria-hidden', 'true');
    wrapper.parentNode.insertBefore(sentinel, wrapper);

    const sticker = document.createElement('div');
    sticker.className = 'ct-direct-buy-sticker';
    sticker.setAttribute('aria-hidden', 'true');

    const stickerButton = document.createElement('button');
    stickerButton.type = 'button';
    stickerButton.className = 'ct-direct-buy-sticker__button';
    stickerButton.tabIndex = -1;
    setDirectBuyButtonLabel(stickerButton);
    sticker.appendChild(stickerButton);
    document.body.appendChild(sticker);

    stickerButton.addEventListener('click', () => {
      const currentButton = wrapper.querySelector(DIRECT_BUY_BUTTON_SELECTOR) || button;
      if (!currentButton || isDisabledButton(currentButton)) return;
      currentButton.click();
    });

    let stickyFrame = null;
    let geometryDirty = true;
    let destroyed = false;
    let sentinelPassed = false;
    let sentinelDocumentTop = 0;
    let lastStickyVisible;
    let lastStickyLoading;
    let sentinelObserver;
    let geometryObserver;
    const destroySticky = () => {
      if (destroyed) return;
      destroyed = true;
      if (stickyFrame !== null) window.cancelAnimationFrame(stickyFrame);
      sentinelObserver?.disconnect();
      geometryObserver?.disconnect();
      window.removeEventListener('scroll', updateSentinelFromScroll);
      window.removeEventListener('resize', refreshSticky);
      if (typeof stickyDirectBuyMedia?.removeEventListener === 'function') {
        stickyDirectBuyMedia.removeEventListener('change', refreshSticky);
      } else if (typeof stickyDirectBuyMedia?.removeListener === 'function') {
        stickyDirectBuyMedia.removeListener(refreshSticky);
      }
      sentinel.remove();
      sticker.remove();
      delete wrapper.ctRefreshSticky;
      delete wrapper.ctUpdateSticky;
      delete wrapper.ctDestroySticky;
      delete wrapper.dataset.ctStickyReady;
      syncStickyBodyState();
    };
    const updateSticky = () => {
      stickyFrame = null;
      if (!wrapper.isConnected) {
        destroySticky();
        return;
      }
      // Button-state mutations do not require measuring layout again.
      if (geometryDirty) {
        sentinelDocumentTop = sentinel.getBoundingClientRect().top + window.scrollY;
        sentinelPassed = window.scrollY > sentinelDocumentTop + 12;
        geometryDirty = false;
      }
      const currentButton = wrapper.querySelector(DIRECT_BUY_BUTTON_SELECTOR) || button;
      const canStick = !stickyDirectBuyMedia || stickyDirectBuyMedia.matches;
      const loading = isDirectBuyLoading(currentButton);
      const shouldStick = canStick && (!isDisabledButton(currentButton) || loading) && sentinelPassed;
      if (loading !== lastStickyLoading) {
        lastStickyLoading = loading;
        stickerButton.classList.toggle('ct-adapter-checkout-loading', loading);
        if (loading) stickerButton.setAttribute('aria-busy', 'true');
        else stickerButton.removeAttribute('aria-busy');
        setDirectBuyButtonLabel(stickerButton, loading);
      }
      if (shouldStick !== lastStickyVisible) {
        lastStickyVisible = shouldStick;
        wrapper.classList.toggle('ct-direct-buy--stuck', shouldStick);
        sticker.classList.toggle('is-visible', shouldStick);
        sticker.setAttribute('aria-hidden', shouldStick ? 'false' : 'true');
        stickerButton.tabIndex = shouldStick ? 0 : -1;
        syncStickyBodyState();
      }
    };

    const scheduleStickyUpdate = () => {
      if (destroyed || stickyFrame !== null) return;
      stickyFrame = window.requestAnimationFrame(updateSticky);
    };

    const updateSentinelFromScroll = () => {
      if (geometryDirty) {
        scheduleStickyUpdate();
        return;
      }
      const nextSentinelPassed = window.scrollY > sentinelDocumentTop + 12;
      if (nextSentinelPassed === sentinelPassed) return;
      sentinelPassed = nextSentinelPassed;
      scheduleStickyUpdate();
    };

    const refreshSticky = () => {
      geometryDirty = true;
      scheduleStickyUpdate();
    };

    window.addEventListener('scroll', updateSentinelFromScroll, { passive: true });

    if ('IntersectionObserver' in window) {
      sentinelObserver = new IntersectionObserver(([entry]) => {
        sentinelPassed = Boolean(entry && !entry.isIntersecting && entry.boundingClientRect.top < 0);
        scheduleStickyUpdate();
      });
      sentinelObserver.observe(sentinel);
    }
    window.addEventListener('resize', refreshSticky);

    if ('ResizeObserver' in window) {
      // Account for image/font/variant changes above the CTA, not just viewport changes.
      geometryObserver = new ResizeObserver(refreshSticky);
      geometryObserver.observe(document.body);
      const productRoot = wrapper.closest('product-info, .product');
      if (productRoot) geometryObserver.observe(productRoot);
    }

    if (stickyDirectBuyMedia) {
      if (typeof stickyDirectBuyMedia.addEventListener === 'function') {
        stickyDirectBuyMedia.addEventListener('change', refreshSticky);
      } else if (typeof stickyDirectBuyMedia.addListener === 'function') {
        stickyDirectBuyMedia.addListener(refreshSticky);
      }
    }

    wrapper.ctRefreshSticky = refreshSticky;
    wrapper.ctUpdateSticky = scheduleStickyUpdate;
    wrapper.ctDestroySticky = destroySticky;
    scheduleStickyUpdate();
  };

  const updateAddToCartButtonText = () => {
    document.querySelectorAll(ADD_TO_CART_BUTTON_SELECTOR).forEach((button) => {
      if (button.matches(PREMIUM_ADD_BUTTON_SELECTOR)) {
        const form = getPremiumButtonForm(button);
        const nativeButton = form?.querySelector('.product-form__submit[name="add"]');
        if (nativeButton) {
          const available = !isDisabledButton(nativeButton);
          const labelText = available ? ADD_TO_CART_TEXT : 'Agotado';
          const label = button.querySelector('span') || button;
          const nextDisabled = !available;
          const nextAriaDisabled = nextDisabled ? 'true' : 'false';
          if (button.disabled !== nextDisabled) button.disabled = nextDisabled;
          if (button.getAttribute('aria-disabled') !== nextAriaDisabled) {
            button.setAttribute('aria-disabled', nextAriaDisabled);
          }
          if (button.getAttribute('aria-label') !== labelText) button.setAttribute('aria-label', labelText);
          if (label.textContent.trim() !== labelText) label.textContent = labelText;
        }
        return;
      }

      if (isDisabledButton(button)) return;

      const label = button.querySelector('span') || button;
      if (label && label.textContent.trim() !== ADD_TO_CART_TEXT) {
        label.textContent = ADD_TO_CART_TEXT;
        button.setAttribute('aria-label', ADD_TO_CART_TEXT);
      }
    });
  };

  const updateDirectBuyButtonText = (refreshGeometry = false) => {
    document.querySelectorAll(DIRECT_BUY_BUTTON_SELECTOR).forEach((button) => {
      initStickyDirectBuyButton(button);
      const wrapper = button.closest('.shopify-payment-button');
      if (refreshGeometry) wrapper?.ctRefreshSticky?.();
      else wrapper?.ctUpdateSticky?.();
      if (isDisabledButton(button) || isDirectBuyLoading(button)) return;

      setDirectBuyButtonLabel(button);
    });
  };

  const updateBuyButtonText = (refreshGeometry = false) => {
    updateAddToCartButtonText();
    updateDirectBuyButtonText(refreshGeometry);
  };

  let buyButtonUpdateFrame;
  let buyButtonGeometryDirty = false;
  const scheduleBuyButtonUpdate = () => {
    if (buyButtonUpdateFrame) return;
    buyButtonUpdateFrame = window.requestAnimationFrame(() => {
      buyButtonUpdateFrame = null;
      const refreshGeometry = buyButtonGeometryDirty;
      buyButtonGeometryDirty = false;
      updateBuyButtonText(refreshGeometry);
    });
  };

  const scheduleBuyButtonLayoutUpdate = () => {
    buyButtonGeometryDirty = true;
    scheduleBuyButtonUpdate();
  };

  const handleDirectBuyClick = (event) => {
    const button = event.target.closest(DIRECT_BUY_BUTTON_SELECTOR);
    if (!button || isDisabledButton(button) || isDirectBuyLoading(button)) return;
    // Capture the usable state before Shopify's own click handler can disable
    // the button. If navigation fails, recovery must return to that state.
    getDirectBuyButtons().forEach(rememberDirectBuyState);
    button.classList.add('ct-direct-buy--engaging');
    window.setTimeout(() => setDirectBuyPending(button), 0);
  };

  const syncPremiumQuantityToForm = (button, form) => {
    const row = button.closest('.custom-premium-cart-row');
    const quantityInput = row ? row.querySelector('.premium-qty-input') : null;
    const quantity = quantityInput ? Number(quantityInput.value || 1) : 1;
    const safeQuantity = Number.isFinite(quantity) && quantity > 0 ? quantity : 1;
    let formQuantityInput = form.querySelector('input[name="quantity"]');

    if (!formQuantityInput) {
      formQuantityInput = document.createElement('input');
      formQuantityInput.type = 'hidden';
      formQuantityInput.name = 'quantity';
      form.appendChild(formQuantityInput);
    }

    formQuantityInput.value = String(safeQuantity);
    formQuantityInput.dispatchEvent(new Event('input', { bubbles: true }));
    formQuantityInput.dispatchEvent(new Event('change', { bubbles: true }));
  };

  const getPremiumButtonForm = (button) => {
    const row = button.closest('.custom-premium-cart-row');
    const linkedInput = row ? row.querySelector('.premium-qty-input[form]') : null;
    const linkedFormId = linkedInput ? linkedInput.getAttribute('form') : '';

    if (linkedFormId) {
      const linkedForm = document.getElementById(linkedFormId);
      if (linkedForm) return linkedForm;
    }

    const productRoot = button.closest('product-info, .product, .product__info-wrapper, .product__info-container, [data-section]');
    const scopedForm = productRoot
      ? productRoot.querySelector('product-form form[action*="/cart/add"], form[data-type="add-to-cart-form"], form[action*="/cart/add"]')
      : null;

    return scopedForm || document.querySelector('product-form form[action*="/cart/add"], form[data-type="add-to-cart-form"]');
  };

  const submitPremiumAddButton = (event) => {
    const button = event.target.closest(PREMIUM_ADD_BUTTON_SELECTOR);
    if (!button || isDisabledButton(button)) return;

    const form = getPremiumButtonForm(button);
    if (!form) return;

    const nativeSubmit = form.querySelector('.product-form__submit[name="add"]');
    if (!nativeSubmit || isDisabledButton(nativeSubmit)) {
      scheduleBuyButtonUpdate();
      return;
    }

    event.preventDefault();
    event.stopImmediatePropagation();

    syncPremiumQuantityToForm(button, form);

    if (typeof form.requestSubmit === 'function') {
      form.requestSubmit(nativeSubmit);
      return;
    }

    const submitEvent = new Event('submit', { bubbles: true, cancelable: true });
    if (form.dispatchEvent(submitEvent)) form.submit();
  };

  const observedBuyButtonRoots = new WeakSet();

  const observeBuyButtonRoots = (scope = document) => {
    const roots = [];
    if (scope instanceof Element && scope.matches('.product-form__buttons, .custom-premium-cart-row')) {
      roots.push(scope);
    }
    scope.querySelectorAll?.('.product-form__buttons, .custom-premium-cart-row').forEach((root) => roots.push(root));

    roots.forEach((root) => {
      if (observedBuyButtonRoots.has(root)) return;
      observedBuyButtonRoots.add(root);
      const observer = new MutationObserver((records) => {
        if (records.some((record) => record.type === 'childList')) scheduleBuyButtonLayoutUpdate();
        else scheduleBuyButtonUpdate();
      });
      observer.observe(root, {
        childList: true,
        subtree: true,
        attributes: true,
        attributeFilter: ['disabled', 'aria-disabled', 'class']
      });
    });
  };

  const initBuyButtonObserver = () => {
    updateBuyButtonText(true);
    observeBuyButtonRoots();

    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.variantChange, scheduleBuyButtonLayoutUpdate);
    } else {
      document.addEventListener('change', (event) => {
        if (event.target instanceof HTMLInputElement && event.target.name === 'id') {
          scheduleBuyButtonLayoutUpdate();
        }
      });
    }

    document.addEventListener('shopify:section:load', (event) => {
      observeBuyButtonRoots(event.target);
      scheduleBuyButtonLayoutUpdate();
    });

    document.addEventListener('shopify:section:unload', (event) => {
      event.target.querySelectorAll('.shopify-payment-button').forEach((wrapper) => wrapper.ctDestroySticky?.());
    });

    document.addEventListener('click', handleDirectBuyClick, true);
    document.addEventListener('ct:direct-buy-loading', (event) => {
      setDirectBuyPending(event.detail && event.detail.button);
    });
    document.addEventListener('ct:direct-buy-error', (event) => {
      resetDirectBuyPending({ showError: true, focusTarget: event.detail && event.detail.button });
    });
    window.addEventListener('pagehide', () => {
      window.clearTimeout(checkoutFailureTimer);
      window.clearTimeout(checkoutProgressTimer);
    });
    window.addEventListener('pageshow', () => {
      resetDirectBuyPending();
      updateBuyButtonText(true);
    });
  };

  const setQuantityForBundle = (root, quantity) => {
    const formId = root.dataset.formId;
    const form = document.getElementById(formId);
    if (!form) return;

    const min = Number(root.dataset.min || 1);
    const max = root.dataset.max ? Number(root.dataset.max) : null;
    const step = Number(root.dataset.step || 1);
    let nextQuantity = Math.max(min, Number(quantity || min));

    if (max && nextQuantity > max) nextQuantity = max;
    if (step > 1) nextQuantity = Math.max(min, min + Math.round((nextQuantity - min) / step) * step);

    const formSelector = `input[name="quantity"][form="${cssEscape(formId)}"]`;
    const formInputs = Array.from(document.querySelectorAll(formSelector));
    const internalInputs = Array.from(form.querySelectorAll('input[name="quantity"]'));
    const inputs = [...new Set([...formInputs, ...internalInputs])];

    if (!inputs.length) {
      const hidden = document.createElement('input');
      hidden.type = 'hidden';
      hidden.name = 'quantity';
      hidden.value = String(nextQuantity);
      form.appendChild(hidden);
      inputs.push(hidden);
    }

    inputs.forEach((input) => {
      input.value = String(nextQuantity);
      input.dispatchEvent(new Event('input', { bubbles: true }));
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  };

  const initQuantityBundles = () => {
    document.querySelectorAll('[data-ct-qty-bundle]').forEach((root) => {
      if (root.dataset.ctReady === 'true') return;
      root.dataset.ctReady = 'true';

      const selected = root.querySelector('[data-ct-qty-option].is-selected') || root.querySelector('[data-ct-qty-option]');
      if (selected) setQuantityForBundle(root, selected.dataset.qty);

      root.querySelectorAll('[data-ct-qty-option]').forEach((option) => {
        option.addEventListener('click', () => {
          root.querySelectorAll('[data-ct-qty-option]').forEach((item) => {
            item.classList.remove('is-selected');
            item.setAttribute('aria-pressed', 'false');
          });
          option.classList.add('is-selected');
          option.setAttribute('aria-pressed', 'true');
          setQuantityForBundle(root, option.dataset.qty);
        });
      });
    });
  };

  const initPremiumAccessibility = () => {
    document.querySelectorAll('.premium-qty-box').forEach((box) => {
      const input = box.querySelector('.premium-qty-input');
      const buttons = box.querySelectorAll('.premium-qty-btn');

      if (input) input.setAttribute('aria-label', 'Cantidad del producto');
      if (buttons[0]) buttons[0].setAttribute('aria-label', 'Reducir cantidad');
      if (buttons[1]) buttons[1].setAttribute('aria-label', 'Aumentar cantidad');
    });

    document.querySelectorAll('.ct-proof-pill, .ct-proof-reviews-button').forEach((button) => {
      button.removeAttribute('aria-label');
    });

    document.querySelectorAll('.ct-premium-trust-card h4').forEach((heading) => {
      heading.setAttribute('role', 'presentation');
    });
  };

  const init = () => {
    initPremiumAccessibility();
    initBuyButtonObserver();
    initQuantityBundles();
  };

  document.addEventListener('click', submitPremiumAddButton, true);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();









